import dragon from './dragon_invite/zh.json';
import exchangeShop from './exchange_shop/zh.json';

export default {
    ...dragon,
    ...exchangeShop
};
